const freezeAtTop = (id) => {
  if (!id) {
    return () => null;
  }
  let rafId = null;
  let element = document.getElementById(id);
  const observer = new MutationObserver(() => {
    element ||= document.getElementById(id);
    if (!element) {
      return;
    }
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      element?.scrollIntoView();
      rafId = null;
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  return () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    observer.disconnect();
  };
};
export {
  freezeAtTop
};
//# sourceMappingURL=freeze-at-top.js.map
